import { useActiveStream } from "@/anticheat/react/useActiveStream";

/**
 * The room a page leaves under its content while the camera tile
 * (`CameraPreview`, fixed bottom-right) is on screen: the tile's height, its
 * caption and its 16 px offset. Without it the tile sat over the last answer
 * option, "Run tests" or a page's primary button with nothing to scroll them
 * clear — pre-ship 2026-10-07 B4 fixed the question page; 2026-10-10 QA-2
 * found the Gate's Welcome step ("Start the test") and every Practice screen
 * still without it. ONE value for every page that renders the tile; it goes
 * on that page's scrolling content.
 */
export const CAMERA_TILE_RESERVE = "pb-36 sm:pb-44";

/**
 * Keeps a page's STICKY footer clear of the tile (Review, SectionReview —
 * their primary button sits bottom-right, exactly under it). The tile is
 * 112 px wide below `sm`, 160 px from it, plus its 16 px offset; a centred
 * `max-w-3xl` row ends past that only from 768 + 2 × 176 px, where the
 * footer's own `px-6` is enough again. The question page needs none: its
 * action bar scrolls with the content under CAMERA_TILE_RESERVE.
 */
export const CAMERA_TILE_FOOTER_CLEAR = "pr-32 sm:pr-44 min-[1120px]:pr-6";

/**
 * EF-8: the tile's caption on an attempt that takes photos — ONE wording for
 * the question page, Review and SectionReview (the Gate's consent sentence is
 * a different, longer string). ⚠ Placeholder copy — the wording is Emilia's.
 */
export function snapshotCaption(intervalS: number): string {
  return `A photo is taken every ${intervalS} s`;
}

/** True while `CameraPreview` renders — a camera stream is live. */
export function useCameraTileShown(): boolean {
  return useActiveStream() !== null;
}
